import Cropper from 'react-easy-crop';


import "../../../ui-styles/cropper/imagecrop.css";
import React, { useState, useCallback } from 'react';

import getCroppedImg from './cropImage';
//import { Button } from '@material-ui/core';
import Slider from '@material-ui/core/Slider';


const Demo = (props) =>
{
  const [ show, setShow ] = useState(1);
  const { imageToCrop, onImageCropped, cropRatio, target } = props;


  const [ crop, setCrop ] = useState({ x: 0, y: 0 });
  const [ zoom, setZoom ] = useState(1);

  const rotation = 0;

  const [ croppedAreaPixels, setCroppedAreaPixels ] = useState(null);

  const setCropConfig = crop;



  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) =>
  {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const getSize = (target) =>
  {

    if (target === "header" || target === "footer")
    {

      return [ 100, 595 ];
    }
    else if (target === "signature" || target === "logo")
    {

      return [ 80, 260 ];

    }

    else return [ null, null ];
  };

  // const imageRef = useState(imageToCrop);


  const cancelCrop = () =>
  {
    //setShow(false)

    props.cancelCrop(false);

    setCropConfig(null);
  };

  const cropImage = async () =>
  {
    //imageRef.current = imageToCrop

    setShow(false);
    //if (imageRef && imageRef.current && cropConfig.width && cropConfig.height) {
    const croppedImage = await getCroppedImg(imageToCrop, croppedAreaPixels, rotation);

    onImageCropped(croppedImage);
    //}
  };

  let [ height, width ] = getSize(target);

  return (

    <>
      {show && <>
        <div className="cropperHdr">
          <span className="hdrTxt"> Crop Image</span>
        </div>
        <div className="cropperContent">
          <div className="croppingBanner">
            {show && <Cropper className="reactCropBlock"
              minZoom={0.1}
              image={imageToCrop}
              restrictPosition={false}
              crop={crop}
              zoom={zoom}
              cropSize={target === "profile" ? null : { width: width, height: height }}
              aspect={target === "profile" ? cropRatio : null}
              onCropChange={setCrop}
              onCropComplete={onCropComplete}
              onZoomChange={setZoom}
            />}
          </div>
          <div className="controls">
            <div className="sliderContainer">
              <p>Zoom</p>
              <Slider
                value={zoom}
                min={0.1}
                max={3}
                step={0.05}
                aria-labelledby="Zoom"
                classes={{ root: 'slider' }}
                onChange={(e, zoom) => setZoom(zoom)}
              />
            </div>
          </div>
        </div>

        <div className="cropperFooter">
          <div className="cropperFooterActionBox" onClick={cancelCrop}>
            <span className="cropperFooterActionTxt">Cancel</span>
          </div>
          <div className="cropperFooterActionBox" onClick={cropImage}>
            <span className="cropperFooterActionTxt">Update</span>
          </div>

        </div>

        {/* <Button variant="contained" style={{height: '60px', width : '150px'}} onClick={cropImage}>Update</Button>
<Button variant="contained" style={{height: '60px', width : '150px'}} onClick={cancelCrop}>Cancel</Button>     */}

      </>}
    </>
  );
};

export default Demo;



// {/* <div className="cropping">
//                   <div className="cropperBranding">
//                       <Cropper className="reactCropBlock"
//                         minZoom={0.1}
//                         image={imageToCrop}
//                         crop={crop}
//                         zoom={zoom}
//                         aspect={16/9}
//                         onCropChange={setCrop}
//                         onCropComplete={onCropComplete}
//                         onZoomChange={setZoom}
//                       />
//                   </div>
//               </div> */}